import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Returns the best available display name for a profile object.
 * Prefers `display_name`, then `first_name + last_name`, then falls back to the
 * provided fallback string (default: "Utilisateur").
 */
export function getDisplayName(
  profile: {
    display_name?: string | null;
    first_name?: string | null;
    last_name?: string | null;
  } | null | undefined,
  fallback = "Utilisateur"
): string {
  if (!profile) return fallback;
  if (profile.display_name) return profile.display_name;
  const full = [profile.first_name, profile.last_name].filter(Boolean).join(" ");
  return full || fallback;
}
